<template>
  <dash-page-new
      :title="$t('Settings')"
      :subtitle="$t('MobileApps')"
      :root="$t('Dashboard')"
      :root-location="businessDashLink('')"
  >

  <ws-accordion
      class="mt-5"
      :items="headerParams"
  >
    <template #action.bundle="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.apple="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.apple_push="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.firebase="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.meta="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.links="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>
    <template #action.screenshots="{forcedExpand , item}">
      <div style="min-width: 150px" class="d-flex justify-end">
        <v-chip
            @click="forcedExpand()"
            dark
            :color="wsACCENT"
            class="px-1 justify-end font-weight-medium pointer mr-5"
        >
          <v-icon small class="ml-2">mdi-{{ !item.expand ? 'pencil' : 'close' }}</v-icon>
          <h5  class="mx-2"> {{ !item.expand  ? $t('Edit') : $t('Cancel') }}</h5>

        </v-chip>
      </div>
    </template>




    <template #item.bundle>

      <div class="pa-6 pb-8 " >
        <v-row>
          <v-col cols="6" >
            <div class="">
              <ws-text-field
                  v-model="bundle.bundle"
                  :placeholder="`ua.westudy.app.${$store.state.business.selectedBusiness.alias}`"
                  width="100%"
                  label="Bundle"
                  class="pr-2"

              />

              <ws-text-field
                  v-model="bundle.APPLE_APP_ID"
                  class="pt-5"
                  label="Apple App Id"
              />
              <ws-text-field
                  v-model="bundle.APPLE_APP_SCHEME"
                  class="pt-5"
                  label="Apple App Scheme"
              />

            </div>
          </v-col>
          <v-col cols="6" class=" align-center pl-4">
            <div class="fill-height d-flex align-center">
              <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
            </div>
          </v-col>
        </v-row>
      </div>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings(bundle)" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.apple>
      <v-row class="pa-6 pb-8">
        <v-col cols="6">

          <ws-text-field
              v-model="appleData.APPLE_ACCOUNT_KEY"
              label="Apple Account Key"
              area
              rows="3"
              :auto-grow="false"
          />
          <ws-text-field
              v-model="appleData.APPLE_ACCOUNT_KEY_ID"
              class="pt-5"
              label="Apple Account Key Id"
          />
          <ws-text-field
              v-model="appleData.APPLE_ACCOUNT_ISSUER_ID"
              class="pt-5"
              label="Apple Issuer Id"
          />

        </v-col>
        <v-col cols="6">
          <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
        </v-col>
      </v-row>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings(appleData)" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.apple_push>

      <v-row class="pa-6 pb-8">
        <v-col cols="6">
          <ws-text-field
              v-model="applePushData.APPLE_AUTH_KEY"
              label="Push Key"
              area
              rows="3"
              :auto-grow="false"
          />
          <ws-text-field
              v-model="applePushData.APPLE_KEY_ID"
              class="pt-5"
              label="Apple Push Key Id"
          />
          <ws-text-field
              v-model="applePushData.APPLE_TEAM_ID"
              class="pt-5"
              label="Apple Team Id"
          />
        </v-col>
        <v-col cols="6">
          <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
        </v-col>
      </v-row>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings(applePushData)" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.firebase>

      <v-row class="pa-6 pb-8">
        <v-col cols="6">

          <ws-text-field
              v-model="firebaseData.GOOGLE_FIREBASE_PRIVATE_KEY"
              label="Firebase Private Key"
              area
              rows="3"
              :auto-grow="false"
          />
          <ws-text-field
              v-model="firebaseData.GOOGLE_FIREBASE_CLIENT_EMAIL"
              class="pt-5"
              label="Firebase Client Email"
          />
          <ws-text-field
              v-model="firebaseData.GOOGLE_FIREBASE_PROJECT_ID"
              class="pt-5"
              label="Firebase Project Id"
          />
        </v-col>
        <v-col cols="6">
          <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
        </v-col>
      </v-row>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings(firebaseData)" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.meta>

      <div class="pa-6 pb-8 " >

        <v-row>
          <v-col cols="6" >

            <h5 class="wsACCENT mb-3 font-weight-regular">App Icon</h5>

            <div class="">

              <v-sheet max-width="550" width="100%" class="mr-4">

                <image-param-picker
                    v-model="appMetaData.APP_ICON"
                    no-border
                    height="240"
                />

              </v-sheet>

              <ws-text-field
                  v-model="appMetaData.APP_NAME"
                  width="100%"
                  label="App Name"
                  placeholder="Введіть назву додатка"
                  class="pr-2 mt-5"
              />

              <ws-text-field
                  v-model="appMetaData.APP_SUBTITLE"
                  width="100%"
                  label="App Subtitle"
                  placeholder="Введіть короткий підзаголовок"
                  class="pr-2 mt-5"
              />

              <ws-text-field
                  v-model="appMetaData.APP_KEYWORDS"
                  width="100%"
                  label="App Keywords"
                  placeholder="Онлайн курси, програмування, дизайн"
                  class="pr-2 mt-5"
              />

              <ws-text-field
                  v-model="appMetaData.APP_PROMOTION"
                  width="100%"
                  label="App Short Description"
                  placeholder="Введіть короткий опис додатка"
                  class="pr-2 mt-5"
                  area
              />

              <ws-text-field
                  v-model="appMetaData.APP_DESCRIPTION"
                  width="100%"
                  label="App Full Description"
                  placeholder="Введіть опис додатка"
                  class="pr-2 mt-5"
                  area
              />


            </div>
          </v-col>
          <v-col cols="6" class=" align-center pl-4">
            <div class="fill-height d-flex align-center">
              <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
            </div>
          </v-col>
        </v-row>

      </div>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings({ app_data : appMetaData})" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.links>

      <div class="pa-6 pb-8 " >
        <v-row>
          <v-col cols="6" >

            <div class="">

              <ws-text-field
                  v-model="appLinks.APPLE_STORE_URL"
                  width="100%"
                  label="AppStore Url"
                  placeholder="Посилання на додаток в AppStore"
                  class="pr-2 mt-5"
              />

              <ws-text-field
                  v-model="appLinks.GOOGLE_STORE_URL"
                  width="100%"
                  label="Google Play Market Url"
                  placeholder="Посилання на додаток в Google Play Market"
                  class="pr-2 mt-5"
              />

              <h5 class="wsACCENT mb-3 mt-5 font-weight-regular">Android APK file</h5>

              <v-sheet max-width="550" width="100%" class="mr-4">


                <ws-file-uploader
                    v-if="!appLinks.GOOGLE_APK_URL"
                    @success="(event) => appLinks.GOOGLE_APK_URL = event.url"
                    v-model="appLinks.GOOGLE_APK_URL"
                    public
                    is-public
                />

                <div v-else class="d-flex justify-space-between align-items-center">

                  <ws-button
                      :href="appLinks.GOOGLE_APK_URL"
                      new-window
                      left-icon="mdi-cog"
                      outlined
                      :color="wsDARKLIGHT"
                      block
                  >
                    <v-icon :color="wsACCENT" class="mr-2">mdi-file</v-icon>
                    <span class="wsACCENT">
                      {{ SHORTEN_FILE_NAME(appLinks.GOOGLE_APK_URL) }}
                    </span>
                    <div class="flex-grow-1"></div>
                    <v-icon :color="wsACCENT">mdi-download</v-icon>
                  </ws-button>

                  <v-btn @click="() => {appLinks.GOOGLE_APK_URL = null;}" :color="wsACCENT" icon>
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>

                </div>

              </v-sheet>



            </div>
          </v-col>
          <v-col cols="6" class=" align-center pl-4">
            <div class="fill-height d-flex align-center">
              <h4 class="wsACCENT font-weight-light mt-6">{{ $t('mobile.settings.bundle.info')  }}</h4>
            </div>
          </v-col>
        </v-row>
      </div>

      <v-sheet :color="wsLIGHTCARD" class="d-flex justify-end px-8 py-3">
        <ws-button @click="editSettings({ app_data : appLinks } )" :loading="LOADING" outlined label="Save"></ws-button>
      </v-sheet>

    </template>
    <template #item.screenshots>

      <div class="pa-6 pb-8 " >

        <div v-for="(value , key) in screenshotDevices" :key="key">

          <h3 class="my-5">{{  value  }}</h3>

          <div class="d-flex align-stretch fill-height overflow-x-auto" style="position:relative; grid-gap: 16px">

            <div  v-for="(img , i) in getScreenshots(key)" :key="key + i" style="position : relative">
              <v-btn  @click="deleteScreenshot(img)" icon small
                      style="position : absolute; right: 12px; top:12px; z-index: 1; background: var(--wsLIGHTCARD)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
              <img :src="img.value" :style="`width: ${getScreenshotWidth(key)}`" class="wsRoundedHalf" />
            </div>


            <v-hover #default="{hover}">
              <v-sheet
                  @click="openAddScreenshot(key)"
                  :color="hover ? wsBACKGROUND : wsLIGHTCARD"
                  :width="getScreenshotWidth(key)"
                  :min-width="getScreenshotWidth(key)"
                  :min-height="getScreenshotWidth(key)"
                  class="d-flex align-center justify-center pointer wsRoundedHalf"
                  style="transition: all 0.3s ease-in-out"
              >
                <v-icon :color="wsATTENTION" large>mdi-plus-circle</v-icon>
              </v-sheet>
            </v-hover>


          </div>





<!--          <image-param-picker-->
<!--              @input="editScreenshot"-->
<!--              v-model="appMetaData.img"-->
<!--              no-border-->
<!--              height="240"-->
<!--          />-->


        </div>

      </div>

    </template>



  </ws-accordion>

    <template #dialog>
      <ws-dialog
          title="Add Screenshot"
          v-model="displayAddScreenshot"
          hide-buttons
      >

        <image-param-picker
            @input="addScreenshot"
            no-border
            height="240"
            disable-portal
        />

      </ws-dialog>
    </template>

</dash-page-new>
</template>


<script>
import {mapActions} from "vuex";
import imageParamPicker from "@/components/AvalonEditor/UI/imageParamPicker.vue";

export default {
  name: "DashMobileAppsDescription",
  components: {imageParamPicker},
  data() {
    return {
      bundle : "",
      appleData : {},
      applePushData : {},
      firebaseData : {},
      appMetaData : {},
      appLinks : {},
      screenshots : [],
      screenshotDevices : {
        "IPHONE" : 'iPhone',
        "IPAD" : 'iPad',
        "ANDROID_PHONE" : 'Android Phone',
        "ANDROID_TABLET" : 'Android Tablet',
      },
      displayAddScreenshot : false,
      addScreenshotType : null


    }
  },
  computed : {
    headerParams() {
      return [
        { name : 'Bundle' ,
          subtitle : this.$t('mobile.settings.bundle.description'),
          value : 'bundle' ,
          icon : 'mdi-image',
          noExpand: true,
          expanded : false
        },
        { name : 'Apple Account' ,
          subtitle : this.$t('mobile.settings.apple.description'),
          value : 'apple' ,
          icon : 'mdi-apple',
          noExpand: true,
          expanded : false
        },
        { name : 'Apple Push' ,
          subtitle : this.$t('mobile.settings.apple_push.description'),
          value : 'apple_push',
          icon : 'mdi-bell-cog-outline',
          expand : false,
          noExpand: true,
          expanded : false
        },
        { name : 'Google Firebase' ,
          subtitle : this.$t('mobile.settings.firebase.description'),
          value : 'firebase' ,
          icon : 'mdi-firebase',
          expand : false,
          noExpand: true,
          expanded : false
        },
        { name : 'Market Meta' ,
          subtitle : 'Налаштуйте метадані додатку: іконка, назва, опис, тощо',
          value : 'meta' ,
          icon : 'mdi-cellphone-information',
          expand : false,
          noExpand: true,
          expanded : false
        },
        { name : 'App Links' ,
          subtitle : 'Посилання на завантаження додатку',
          value : 'links' ,
          icon : 'mdi-link',
          expand : false,
          noExpand: true,
          expanded : false
        },
        { name : 'App Screenshots' ,
          subtitle : 'Завантажте скріншоти вашого додатку',
          value : 'screenshots' ,
          icon : 'mdi-cellphone-screenshot',
          expand : false,
          noExpand: true,
          expanded : false
        },


      ]
    },
  },
  methods : {

    ...mapActions('mobileapps' , [
      'GET_MOBILE_APPS_SETTINGS',
      'EDIT_MOBILE_APPS_SETTINGS'
    ]),

    getScreenshotWidth(type) {
      return (type.includes('IPAD') || type.includes('TABLET')) ? '250px' : '150px'
    },

    openAddScreenshot(type) {
      this.addScreenshotType = type
      this.displayAddScreenshot = true
    },

    deleteScreenshot(item) {

      const index = this.screenshots.indexOf(item)

      this.screenshots.splice(index, 1)

      this.editSettings({ screenshots : this.screenshots })

    },
    addScreenshot(url) {

      this.screenshots.push({
        type : `SCREENSHOT_${this.addScreenshotType}`,
        value : url
      })
      this.displayAddScreenshot = false

      this.editSettings({ screenshots : this.screenshots })

    },

    getScreenshots(type = 'IPHONE')  {
      return this.screenshots.filter(el => el.type === `SCREENSHOT_${type}`)
    },

    async editSettings(entityData) {

      let result = await this.EDIT_MOBILE_APPS_SETTINGS(entityData)
      
      if (!result) {
        return this.ERROR()
      }
      
      this.notify(this.$t('ChangesSaved'))
    },

    async initPage() {
      let result = await this.GET_MOBILE_APPS_SETTINGS()
      
      if (!result) {
        return this.ERROR()
      }
      
      this.bundle = {
        bundle : result.bundle,
        APPLE_APP_ID : result.APPLE_APP_ID,
        APPLE_APP_SCHEME : result.APPLE_APP_SCHEME,
      }
      this.appleData = {
        APPLE_ACCOUNT_KEY : result.APPLE_ACCOUNT_KEY,
        APPLE_ACCOUNT_KEY_ID : result.APPLE_ACCOUNT_KEY_ID,
        APPLE_ACCOUNT_ISSUER_ID : result.APPLE_ACCOUNT_ISSUER_ID
      }
      this.applePushData = {
        APPLE_AUTH_KEY : result.APPLE_AUTH_KEY,
        APPLE_KEY_ID : result.APPLE_KEY_ID,
        APPLE_TEAM_ID : result.APPLE_TEAM_ID,
      }

      this.firebaseData = {
        GOOGLE_FIREBASE_CLIENT_EMAIL : result.GOOGLE_FIREBASE_CLIENT_EMAIL,
        GOOGLE_FIREBASE_PROJECT_ID : result.GOOGLE_FIREBASE_PROJECT_ID,
        GOOGLE_FIREBASE_PRIVATE_KEY : result.GOOGLE_FIREBASE_PRIVATE_KEY,
      }

      this.appMetaData = {
        APP_ICON : result.app_data.APP_ICON,
        APP_NAME : result.app_data.APP_NAME || null,
        APP_SUBTITLE : result.app_data.APP_SUBTITLE || null,
        APP_KEYWORDS : result.app_data.APP_KEYWORDS || null,
        APP_PROMOTION : result.app_data.APP_PROMOTION || null,
        APP_DESCRIPTION : result.app_data.APP_DESCRIPTION || null,
      }

      this.appLinks = {
        APPLE_STORE_URL : result.app_data.APPLE_STORE_URL || null,
        GOOGLE_STORE_URL : result.app_data.GOOGLE_STORE_URL || null,
        GOOGLE_APK_URL : result.app_data.GOOGLE_APK_URL || null
      }

      this.screenshots = result.screenshots

    }
  },
  mounted() {
    this.initPage()
  }
}
</script>

<style scoped>

</style>